import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';

import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-loading-dialog',
	templateUrl: './loading-dialog.component.html',
	styleUrl: './loading-dialog.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, LoadingSpinnerComponent, MatDialogModule]
})
export class LoadingDialogComponent {}
